const PRINT_FRAME_ID = 'pdf-print-frame';

const PDF = 'application/pdf';

let previousObjectUrl: string | null = null;

const clearPreviousPrint = (): void => {
  document.getElementById(PRINT_FRAME_ID)?.remove();
  if (previousObjectUrl !== null) URL.revokeObjectURL(previousObjectUrl);
  previousObjectUrl = null;
};

const hiddenFrameOf = (objectUrl: string): HTMLIFrameElement => {
  const frame = document.createElement('iframe');
  frame.id = PRINT_FRAME_ID;
  frame.title = PRINT_FRAME_ID;
  frame.setAttribute('aria-hidden', 'true');
  frame.tabIndex = -1;
  Object.assign(frame.style, {
    position: 'fixed',
    inset: '0',
    width: '0',
    height: '0',
    border: '0',
    opacity: '0',
  });
  frame.src = objectUrl;
  return frame;
};

const openPrintDialog = (frame: HTMLIFrameElement, objectUrl: string): void => {
  const view = frame.contentWindow;
  if (view === null) {
    window.open(objectUrl, '_blank', 'noopener');
    return;
  }
  view.focus();
  view.print();
};

export const printPdf = async (url: string): Promise<void> => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`label file answered ${String(response.status)}`);
  const pdf = new Blob([await response.arrayBuffer()], { type: PDF });
  clearPreviousPrint();
  const objectUrl = URL.createObjectURL(pdf);
  previousObjectUrl = objectUrl;
  const frame = hiddenFrameOf(objectUrl);
  frame.addEventListener('load', () => {
    openPrintDialog(frame, objectUrl);
  });
  document.body.append(frame);
};
